import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AsvConsultationGenDocHdrLinkModel } from '../../../../../models/aggregates/asv/asv-consultation-gendoc-hdr-link.model';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '..';

@Injectable({
    providedIn: 'root'
  })

  export class AsvConsultationChecklistGenDocHdrService extends BaseApiTemplateService<AsvConsultationGenDocHdrLinkModel> {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ASV_PREFIX + 'consultation/gendoc-hdr-links';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation/gendoc-hdr-links/backoffice-ep';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ASV_PREFIX + 'consultation/gendoc-hdr-links/backoffice-ep';
        this.httpClient = http;
      }
}